<template>
  <div>
    <page-header :title="$t('inspection.title.env_inspection')" />
    <page-body>
      <list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'InspectionIndex',
  components: {
    List,
  },
  data () {
    return {
      listId: 'InspectionList',
    }
  },
}
</script>

<style>

</style>
